import useSWR, { SWRResponse } from 'swr';
import { GeoCodeResult } from '../../providers/geo/dtos';
import { geocodeByAddress } from '../../providers/geo/geocode/geocodeProvider';

export const GEOCODE_BY_ADDRESS_RID = '/geocode-by-address';

export function useGeocodeByAddress(address?: string): SWRResponse<GeoCodeResult[], Error> {
  return useSWR(address ? [GEOCODE_BY_ADDRESS_RID, address] : null, () => geocodeByAddress(address!));
}
